export class SignalUser{
    Id: bigint;
    ClientId: string;
    ConnectionId: string;
    User: string;
    Identifier: string;
    ConnectionDate: Date;
}